// extracted by mini-css-extract-plugin
module.exports = {"imgAckStatusOverlay":"attendance-acknowledgement_imgAckStatusOverlay__1o62G"};